<template>
  <div>
    <h3 class="md-title">
      <md-icon>trip_origin</md-icon>
      {{ $route.name }}
    </h3>
    <div class="md-layout md-size-100">
      <div class="md-layout-item md-size-20 no-padding">
        <md-card>
          <md-card-header md-alignment="space-between">
            <h4 class="title">
              <md-icon>search</md-icon>
              교우 선택
            </h4>
          </md-card-header>
          <md-card-content>
            <div class="mb10">
              <div style="position: relative; padding-right: 90px;">
                <md-button v-focus slot="footer" class="md-info md-sm full-size-button" @click="() => {this.isShowMemberModal = true}">
                  <md-icon>open_in_new</md-icon>교우 검색
                </md-button>
                <label style="position: absolute; top: 5px; right: 0;"><input type="checkbox" v-model="isGubun" @change="onChangeGubun"><span style="font-size: 16px;">기타회비</span></label>
              </div>
            </div>
            <h5 class="title">
              납부 내역 요약
              <span style="color: red" v-show="summary.memberGb == 'Y'">(평생회비)</span>
            </h5>
            <table class="flex-table">
              <tr>
                <th>교우번호</th>
                <td class="ta-c">
                  <span>{{ summary.memberNo }}</span>
                </td>
              </tr>
              <tr>
                <th>교우명</th>
                <td class="ta-c">
                  <span>{{ summary.memberHnm }}</span>
                </td>
              </tr>
              <tr>
                <th>납입횟수</th>
                <td class="ta-r">
                  <span>{{ summary.totalCount }}</span>
                </td>
              </tr>
              <tr>
                <th>납입금액</th>
                <td class="ta-r">
                  <span>{{ summary.totalAmount ? formatter.getCurrency(summary.totalAmount) :  summary.totalAmount}}</span>
                </td>
              </tr>
              <tr>
                <th>최초납입일</th>
                <td class="ta-c">
                  <span>{{ summary.firstFee }}</span>
                </td>
              </tr>
              <tr>
                <th>최종납입일</th>
                <td class="ta-c">
                  <span>{{ summary.lastFee }}</span>
                </td>
              </tr>
            </table>
          </md-card-content>
        </md-card>
        <md-card>
          <md-card-header md-alignment="space-between">
            <h4 class="title">
              <md-icon>assignment</md-icon>납부 상세 정보
            </h4>
          </md-card-header>
          <md-card-content>
            <div :class="{ mb10 : isShowWrite }">
              <md-button class="md-info md-sm full-size-button" :disabled="summary.memberNo === undefined" @click="createFeeItem">
                <md-icon>check</md-icon>신규등록
              </md-button>
            </div>

            <table class="flex-table" v-if="isShowWrite">
              <tr>
                <th>납부일자</th>
                <td>
                  <div class="inline-flex">
                    <input type="text" v-model="fee.feeDate" v-mask="'####-##-##'" :disabled="isEditMode">
                  </div>
                </td>
              <tr>
                <th>회비구분</th>
                <td>
                  <select v-model="selectedFeeCd" @change="changeFeeCd">
                    <option value="">선택</option>
                    <option v-for="item in feeCdList" :key="item.code"  v-bind:value="item" :label="item.codeNm"></option>
                  </select>
                </td>
              </tr>
              <tr>
                <th>회비년도</th>
                <td>
                  <input type="text" v-model="fee.feeYear">
                </td>
              </tr>
              <tr>
                <th>납입금액</th>
                <td>
                  <input type="text" v-model="fee.feeAmt" v-mask="'##########'">
                </td>
              </tr>
              <tr>
                <th>납부방법</th>
                <td>
                  <div class="inline-flex">
                    <select v-model="fee.feeWay">
                      <option value="">선택</option>
                      <option v-for="item in feeWayList" :key="item.code" :value="item.code" :label="item.codeNm"></option>
                    </select>
                    <span v-show="fee.feeWay == '03'" >은행</span>
                    <select v-model="fee.bankCd" v-show="fee.feeWay == '03'">
                      <option value="">선택</option>
                      <option v-for="item in bankCdList" :key="item.code" :value="item.code" :label="item.codeNm"></option>
                    </select>
                  </div>
                </td>
              </tr>
              <tr>
                <th>비고</th>
                <td>
                  <textarea v-model="fee.feeEtc"></textarea>
                </td>
              </tr>
              <tr>
                <th>알림톡 발송</th>
                <td>
                    <input type="checkbox" v-model="isTalk">
                </td>
              </tr>
            </table>
          </md-card-content>
          <md-card-actions md-alignment="right" v-if="isShowWrite">
            <md-button class="md-info md-sm" @click="saveFee">
              <md-icon>check</md-icon>
              {{ isEditMode ? "변경 저장" : "등록" }}
            </md-button>
            <md-button class="md-default md-sm" v-if="isEditMode" @click="deleteFee">
              <md-icon>clear</md-icon>삭제
            </md-button>

          </md-card-actions>
        </md-card>
      </div>
      <div class="md-layout-item md-size-80 no-padding">
        <md-card>
          <md-card-header md-alignment="space-between">
            <h4 class="title">
              <md-icon>assignment</md-icon>납부 상세 내역
            </h4>
          </md-card-header>

          <md-card-content>
            <div class="table-header-info">
              <div>총 {{ total }} 건의 검색결과가 있습니다.</div>
              <div>
                <select v-model="pagination.perPage" name="pages" @change="perPageChange">
                  <option v-for="item in pagination.perPageOptions" :key="item" :label="item" :value="item">
                    {{ item }}
                  </option>
                </select>
              </div>
            </div>

            <grid ref="executivesGrid"
                  :data="gridProps.data"
                  :columns="gridProps.columns"
                  :options="gridProps.options"
                  :theme="gridProps.theme"
                  :rowHeaders="gridProps.rowHeaders"
                  :columnOptions="gridProps.columnOptions"
                  :language="gridProps.lang"
                  @click="onClickFeeItem"
                  @response="response"></grid>

          </md-card-content>
          <md-card-actions md-alignment="right">
          </md-card-actions>
        </md-card>
      </div>
    </div>


    <!--교우검색 팝업 -->
    <member-search-pop-comp :is-show.sync="isShowMemberModal" @returnResult="onClickModalMember"></member-search-pop-comp>

  </div>
</template>

<script>
import kuaaApi from "@/kuaa/kuaa-api";
import URL_CONST from "@/kuaa/kuaa-url-const";
import formatter from "@/kuaa/kuaa-formatter";
import kuaaFnc from "@/kuaa/kuaa-comm-func";
import { ko } from "vuejs-datepicker/dist/locale";
import vuejsDatepicker from "vuejs-datepicker";
import Swal from "sweetalert2";
import moment from "moment";

import { Grid } from '@toast-ui/vue-grid';

import { MemberSearchPopComp, WorkSearchPopComp, CompanySearchPopComp, CollegeSearchPopComp, ClassSearchPopComp, NationSearchPopComp, PostcodePopComp } from "@/pages"

export default {
  components: {
    grid: Grid,
    MemberSearchPopComp,
    // vuejsDatepicker
  },

  props: {
    memberNo: {
      type: String,
      default : null
    }
  },

  created() {
    this.initGrid();
    this.clearForm();
    this.queryFeeYear();
    this.queryFeeCd();
    this.queryFeeWay();
    this.queryBankCdTypes();
    if(this.memberNo){
      this.getMemberInfoById();
    }
  },

  computed: {
    total() {
      return this.pagination.total;
    }
  },

  watch: {
    isEditMode: function(){
        if(this.isEditMode) this.isTalk = false;
        else                this.isTalk = true;
    }
  },

  data(){
    return{
      formatter,
      isShowWrite: false,
      isEditMode: false,
      isGubun : false,

      feeYearList: [],
      feeCdList: [],
      feeWayList: [],
      bankCdList: [],

      profile: {},
      summary: {},// 왼쪽 영역 납부 내역 요약
      fee: {},// 납부 상세 영역

      selectedFeeCd : null,

      pagination: {
        perPage: 20,
        page: 1,
        perPageOptions: [20, 50, 100, 200, 500],
        total: 0
      },

      // 교우 검색 A (새로운 교우 세팅 모달용)
      isShowMemberModal: false,
      datepickerLang: ko,
      isTalk: true,
    };
  },

  methods: {
    initGrid() {
      this.gridProps = kuaaFnc.setGridInit(URL_CONST.GET_FEE_LIST, false, this.pagination);
      this.gridProps['el'] = this.$refs.executivesGrid;
      this.gridProps['columns']= [
          {header: '회비년도', name: 'feeYear', align:"center", sortable: true},
          {header: '납부일자', name: 'feeDate', align:"center", sortable: true},
          {header: '납입금액', name: 'feeAmt', sortable: true,
            formatter(value) {return value.value ? formatter.getCurrency(value.value) : null;},
            align:"right"
          },
          {header: '회비구분', name: 'feeCdNm', align:"center", sortable: true},
          {header: '납입구분', name: 'feeGbNm', align:"center", sortable: true},
          {header: '납부방법', name: 'feeWayNm', align:"center", sortable: true},
          {header: '고객납부일', name: 'feeRecvdate', align:"center", sortable: true},
          {header: '송금은행', name: 'bankCdNm', sortable: true},
          {header: '비고', name: 'feeEtc'},
          {header: '회비구분', name: 'feeCd', hidden:true, align:"center"},
          {header: '납입구분', name: 'feeGb', hidden:true, align:"center"},
          {header: '납부방법', name: 'feeWay', hidden:true, align:"center"},
        ];
      this.gridProps['options'].bodyHeight = 550;
    },
    response(e) {
      this.$refs.executivesGrid.invoke("clear");
      this.clearForm();
      this.isEditMode = false;
      this.isShowWrite = false;
      
      let res = JSON.parse(e.xhr.response);
      if(res.result){
        this.pagination.total = res.data.pagination.totalCount;
      }else{
        kuaaFnc.gridErrorCallback(e,"회비개별처리");
      }
    },
    perPageChange(event) {
      kuaaFnc.resetPagenation(this.$refs.executivesGrid, event, this.pagination);
    },

    getMemberInfoById(){
      kuaaApi.sendServer(
        URL_CONST.GET_MEMBER_LIST,
        {"memberNo": this.memberNo},
        "post",
        response => {
          this.onClickModalMember(response.data.data.contents[0]);
        }
      );
    },

    /**
     * 회비년도는 현재년도로부터 과거 10년
     */
    queryFeeYear() {
      let thisYear = new Date().getUTCFullYear();
      let yearList = [];
      for(let i = 0; i < 10; i++){
        yearList.push(thisYear - i)
      }
      this.feeYearList = yearList;
    },

    /**
     * 납입구분코드
     */
    queryFeeCd() {
      kuaaFnc.fncFeeCdTypes(null,res => {
        this.feeCdList = res.data.data.contents;
      });
    },

    /**
     * 납부방법코드 조회
     */
    queryFeeWay() {
      kuaaFnc.fncFeeWayTypes(null,res => {
        this.feeWayList = res.data.data.contents;
      });
    },



    /**
     * 납부방법코드 - 공통코드 조회 세팅
     */
    queryBankCdTypes() {
      kuaaFnc.fncBankCodes(null,res => {
        this.bankCdList = res.data.data.contents;
      });
    },

    /**
     * 모달 교우선택 목록에서 교우를 선택 (교우 변경 기능)
     */
    onClickModalMember(item) {
      this.isCreateMode = false;
      this.isShowMemberModal = false;
      this.profile = item;
      let options = {
        memberNo: this.profile.memberNo, gubun:this.isGubun ? '2' : '1'
      };
      this.$refs.executivesGrid.invoke("readData", 1, options);
      kuaaApi.sendServer(URL_CONST.GET_TOTAL_FEE_INFO, options, "post", response => {
        
        let result = response.data.data.contents;
        if(result) {

          if (result.firstFee && result.firstFee != '') {
            result.firstFee = moment(result.firstFee).format("YYYY-MM-DD");
          }
          if (result.lastFee && result.lastFee != '') {
            result.lastFee = moment(result.lastFee).format("YYYY-MM-DD");
          }
          this.summary = result;
        }else{
          this.summary = this.profile;
          this.fee.memberNo = this.profile.memberNo;
          kuaaFnc.showSwal("회비개별처리", '납부내역이 없습니다.');
          return;
        }
      });
    },

    onClickFeeItem(item) {
      if(item.instance.getRow(item.rowKey) != null) {
        this.isEditMode = true;
        this.isShowWrite = true;
        this.fee = item.instance.getRow(item.rowKey);
        this.fee.orgFeeCd = this.fee.feeCd;
        this.fee.feeDate = moment(this.fee.feeDate).format("YYYY-MM-DD");
        this.feeCdList.forEach((obj)=>{
          if(obj.code == this.fee.feeCd){
            this.selectedFeeCd = obj;
          }
        })
      }
    },

    clearForm() {
      this.fee = {
        feeDate: moment().format("YYYYMMDD"),
        feeYear: kuaaFnc.getCurrentYear(),
        feeCd: "",
        feeCdNm: "",
        feeAmt: "",
        feeWay: "",
        feeEtc: "",
        bankCd : "",
        feeGb : "01",
        orgFeeCd: ""
      };
      this.selectedFeeCd = "";
    },

    createFeeItem() {
      this.isEditMode = false;
      this.isShowWrite = true;
      this.clearForm();
    },

    saveFee() {
      let _this = this;

      if(!this.fee.feeCd || this.fee.feeCd == ''){
        Swal.fire(kuaaFnc.getSwalModaloptions({
          html: "회비구분을 선택 하세요.",
        }))
        return;
      }

      if(!this.fee.feeAmt || this.fee.feeAmt == ''){
        Swal.fire(kuaaFnc.getSwalModaloptions({
          html: "납입금액을 입력 하세요.",
        }))
        return;
      }

      if(this.fee.feeAmt.length < 4){
        Swal.fire(kuaaFnc.getSwalModaloptions({
          html: "납입금액을 확인 하세요.",
        }))
        return;
      }
      
      if(!this.fee.feeWay || this.fee.feeWay == ''){
        Swal.fire(kuaaFnc.getSwalModaloptions({
          html: "납부방법을 선택 하세요.",
        }))
        return;
      }

      if(this.fee.feeWay  == '03' && (!this.fee.bankCd || this.fee.bankCd == '')){
        Swal.fire(kuaaFnc.getSwalModaloptions({
          html: "은행을 선택 하세요.",
        }))
        return;
      }

      let apiUrl = this.isEditMode ? URL_CONST.UPDATE_FEE : URL_CONST.SAVE_FEE;
      this.fee.memberNo = this.profile.memberNo;
      // datepick 포멧에 따른 에러로 인한 object copy
      let params = JSON.parse(JSON.stringify(this.fee));
      if(params.feeDate && params.feeDate!=''){
        params.feeDate = this.customFormatter(params.feeDate);
      }

      Swal.fire(kuaaFnc.getSwalModaloptions('confirm',{
        html: "요청을 처리하시겠습니까?",
      })).then(result => {
        if (result.value) {
          kuaaApi.sendServer(
              apiUrl,
              params,
              "post",
              response => {
                if (response.data.success) {
                  this.clearForm();

                  // 변경 또는 알림톡 미발송
                  if(_this.isEditMode || !this.isTalk){
                    let options = {
                      memberNo: _this.profile.memberNo, gubun: _this.isGubun ? '2' : '1'
                    };
                    _this.$refs.executivesGrid.invoke("readData", _this.$refs.executivesGrid.invoke("getPagination")._currentPage, options);
                    _this.onClickModalMember(options);
                    return false;
                  }

                  _this.sendKakaoTalk(params).then(function(){
                    let options = {
                      memberNo: _this.profile.memberNo, gubun: _this.isGubun ? '2' : '1'
                    };
                    _this.$refs.executivesGrid.invoke("readData", _this.$refs.executivesGrid.invoke("getPagination")._currentPage, options);
                    _this.onClickModalMember(options);
                  });

                } else {
                  kuaaFnc.showSwal("회비개별처리", res.resultMessage);
                }
              }
          );
        }
      });


    },

    deleteFee() {

      if(!this.fee.memberNo){
        Swal.fire(kuaaFnc.getSwalModaloptions({
          html: "삭제할 납부상세내역을 선택 하세요.",
        }))
        return;
      }

      let params = {
        memberNo : this.fee.memberNo,
        feeTime : this.fee.feeTime,
        feeDate : this.fee.feeDate && this.fee.feeDate != '' ? this.customFormatter(this.fee.feeDate) : null,
        feeCd: this.fee.feeCd
      };
      let modalOptions = kuaaFnc.getSwalModaloptions('confirm',{
        html: "해당 납부내역을 삭제하시겠습니까?",
      });
      Swal.fire(modalOptions).then(result => {
        if (result.value) {
          kuaaApi.sendServer(
            URL_CONST.DELETE_FEE,
            params,
            "post",
            response => {
              if (response.data.success){
                this.clearForm();
                kuaaFnc.showSwal("회비개별처리 삭제", '납부 내역이 삭제 되었습니다');
                let options = {
                  memberNo: this.profile.memberNo, gubun: this.isGubun ? '2' : '1'
                };
                this.$refs.executivesGrid.invoke("readData", 1, options);
                this.onClickModalMember(options);

              } else {
                kuaaFnc.showSwal("회비개별처리 삭제", res.resultMessage);
              }
            }
          );
        }
      });
    },
    customFormatter(date) {
      let res = date && date != '' ? moment(date).format("YYYYMMDD") : '';
      return res;
    },
    changeFeeCd(){
      this.fee.feeCd = this.selectedFeeCd.code;
      this.fee.feeCdNm = this.selectedFeeCd.codeNm;
      this.fee.feeAmt = this.selectedFeeCd.etcMeta2;
    },
    onChangeGubun(){
      if(this.summary.memberNo){
        this.onClickModalMember(this.summary);
      }
    },

    async sendKakaoTalk(params){
      try {
          let apiparams = {
            UserID: "kuaa1905",
            UserPW: "kou1905!",
            Service: "ATALK",
            Type: "Send",
            Fail_To: "LMS",
            Subject: "회비납부안내",
            Template_Seq: "4765",
            Callback: "15881905",
            Fail_To_Template: "1",
            Main_Text : "LMS로 전환됩니다.",
            Destination: '[{\"Company\": \"고려대학교교우회\",\"Name\": \"' + this.profile.memberHnm + '\",\"Phone\": \"' + this.profile.cellular + '\",\"Replace_Datas\": [{\"Key\": \"#{이름}\", \"Value\": \"' + this.profile.memberHnm + '\"},{\"Key\": \"#{기타1}\", \"Value\": \"' + formatter.getDateFormat(params.feeDate) + '\"},{\"Key\": \"#{기타2}\", \"Value\": \"' + params.feeCdNm + '\"},{\"Key\": \"#{기타3}\", \"Value\": \"' + formatter.getCurrency(params.feeAmt) + '원\"}]}]'
          }
          return await kuaaApi.sendServer2(
              "https://balsong.com/Linkage/API/",
              apiparams,
              "post"
          );
      }catch{
//console.log("======= exception ========")
//        return true;
      }
    }
  }
};
</script>
<style scoped>
  .flex-table .ta-c {text-align: center;}
  .flex-table .ta-r {text-align: right;}
</style>